/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Translation_MergeInputs */

const en_event_group_options_translation_merge = /** @type {(inputs: Event_Group_Options_Translation_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation Merge`)
};

const fr_event_group_options_translation_merge = /** @type {(inputs: Event_Group_Options_Translation_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusion de traduction`)
};

const de_event_group_options_translation_merge = /** @type {(inputs: Event_Group_Options_Translation_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzungszusammenführung`)
};

const it_event_group_options_translation_merge = /** @type {(inputs: Event_Group_Options_Translation_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unione di traduzioni`)
};

const ru_event_group_options_translation_merge = /** @type {(inputs: Event_Group_Options_Translation_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Слияние переводов`)
};

const es_event_group_options_translation_merge = /** @type {(inputs: Event_Group_Options_Translation_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusión de traducciones`)
};

const zh_cn2_event_group_options_translation_merge = /** @type {(inputs: Event_Group_Options_Translation_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻译合并`)
};

const ja_event_group_options_translation_merge = /** @type {(inputs: Event_Group_Options_Translation_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳マージ`)
};

const hi_event_group_options_translation_merge = /** @type {(inputs: Event_Group_Options_Translation_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद विलय`)
};

const pt_pt2_event_group_options_translation_merge = /** @type {(inputs: Event_Group_Options_Translation_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusão de traduções`)
};

/**
* | output |
* | --- |
* | "Translation Merge" |
*
* @param {Event_Group_Options_Translation_MergeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_translation_merge = /** @type {((inputs?: Event_Group_Options_Translation_MergeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Translation_MergeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_translation_merge(inputs)
	if (locale === "de") return de_event_group_options_translation_merge(inputs)
	if (locale === "it") return it_event_group_options_translation_merge(inputs)
	if (locale === "ru") return ru_event_group_options_translation_merge(inputs)
	if (locale === "es") return es_event_group_options_translation_merge(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_translation_merge(inputs)
	if (locale === "ja") return ja_event_group_options_translation_merge(inputs)
	if (locale === "hi") return hi_event_group_options_translation_merge(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_translation_merge(inputs)
	return en_event_group_options_translation_merge(inputs)
});